import {
  ISSUE_FIELD_ACTION_DUE_DATE,
  ISSUE_FIELD_ACTION_OWNER,
  ISSUE_FIELD_ACTION_STATUS,
  ISSUE_FIELD_DUE_DATE,
  ISSUE_FIELD_ISSUE_STATUS,
  ISSUE_FIELD_ISSUE_SUBTYPE,
  ISSUE_FIELD_ISSUE_TYPE,
  ISSUE_FIELD_OWNER,
} from '@issuemanager/constants';
import type {
  GridColumnVisibilityModel,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import { DefaultFilterModelType } from './data-grid-context';

export const getSortingModelByField = (
  sortModel: GridSortModel,
  field: string,
) => {
  const model = sortModel.find((s) => s.field === field)?.sort ?? undefined;
  return model;
};

export const removeFromFilterByVisibility = (
  visibilityModel: GridColumnVisibilityModel,
  filterMode: DefaultFilterModelType,
): DefaultFilterModelType =>
  Object.entries(filterMode).reduce((filters, [key, value]) => {
    const newFilters = { ...filters };
    if (shouldIncludeInFilter(key, visibilityModel)) {
      newFilters[key] = value;
    }
    return newFilters;
  }, {} as DefaultFilterModelType);

// eslint-disable-next-line max-len
// NOTE: we have columns that are shared between issues and actions. And also the case of issue type + issue subtype (path)
// First value is the real column. Second value is the column that is shared with the first one.
const columnSharedVisibilityPairs = [
  [ISSUE_FIELD_ISSUE_TYPE, ISSUE_FIELD_ISSUE_SUBTYPE],
  [ISSUE_FIELD_ISSUE_STATUS, ISSUE_FIELD_ACTION_STATUS],
  [ISSUE_FIELD_DUE_DATE, ISSUE_FIELD_ACTION_DUE_DATE],
  [ISSUE_FIELD_OWNER, ISSUE_FIELD_ACTION_OWNER],
];

const shouldIncludeInFilter = (
  key: string,
  visibilityModel: GridColumnVisibilityModel,
): boolean => {
  const sharedPair = columnSharedVisibilityPairs.find((pair) =>
    pair.includes(key),
  );

  if (sharedPair) {
    const [key1] = sharedPair;
    return visibilityModel[key1] !== false;
  }

  return visibilityModel[key] !== false;
};
